import { InfoCard, ButtonContainer } from "@/components";
import {
  RastreioContainer,
  InfoCards,
  LinkTracking,
  InfoCardContainer,
  TitleContent,
  TrackingSummary,
  TrackingSummaryItem,
  TrackingSummaryLabel,
  TrackingSummaryValue,
  JadlogTable,
} from "./style";
import { useRastreio } from "./useRastreio";
import { formatDeliveryDate, formatEventDate } from "@/utils/formatDate";

export function Rastreio() {
  const {
    order,
    jadlogTracking,
    jadlogError,
    isLoadingJadlog,
    isJadlogCarrier,
    totalExpressShipment,
    totalExpressError,
    isLoadingTotalExpress,
    isTotalExpressCarrier,
    patrusData,
    patrusError,
    isLoadingPatrus,
    isPatrusCarrier,
  } = useRastreio();

  return (
    <RastreioContainer>
      <InfoCards>
        <InfoCard
          title="Endereço"
          labels={[
            "Rua",
            "Número",
            "Complemento",
            "Bairro",
            "Cidade / UF",
            "CEP",
          ]}
          values={[
            order?.shippingData.address.street,
            order?.shippingData.address.number,
            order?.shippingData.address.complement,
            order?.shippingData.address.neighborhood,
            order?.shippingData.address.city + " / " + order?.shippingData.address.state,
            order?.shippingData.address.postalCode,
          ]}
        />

        <InfoCard
          title="Entrega"
          labels={[
            "Transporte",
            "Código de rastreio",
            "URL de rastreio",
          ]}
          values={[
            order?.shippingData.logisticsInfo[0].deliveryCompany,
            order?.packageAttachment.packages[0]?.trackingNumber || "Não disponível",
            order?.packageAttachment.packages[0]?.trackingUrl ? (
              <LinkTracking
                href={order?.packageAttachment.packages[0]?.trackingUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Acessar
              </LinkTracking>
            ) : (
              "Não disponível"
            ),
          ]}
        />
      </InfoCards>

      {isJadlogCarrier && <InfoCardContainer>
        <TitleContent>
          <h3>Rastreamento Jadlog</h3>
        </TitleContent>

        {isLoadingJadlog && (
          <p style={{ padding: '0 16px 12px', fontSize: 13, color: 'var(--color-text-secondary)' }}>
            Buscando rastreamento...
          </p>
        )}

        {!isLoadingJadlog && jadlogError && (
          <p style={{ padding: '0 16px 12px', fontSize: 13, color: 'var(--color-text-secondary)' }}>
            {jadlogError}
          </p>
        )}

        {!isLoadingJadlog && jadlogTracking?.tracking && (
          <>
            <TrackingSummary>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>Status atual</TrackingSummaryLabel>
                <TrackingSummaryValue>{jadlogTracking.tracking.status}</TrackingSummaryValue>
              </TrackingSummaryItem>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>Previsão de entrega</TrackingSummaryLabel>
                <TrackingSummaryValue>
                  {jadlogTracking.previsaoEntrega
                    ? formatDeliveryDate(jadlogTracking.previsaoEntrega)
                    : '—'}
                </TrackingSummaryValue>
              </TrackingSummaryItem>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>Código Jadlog</TrackingSummaryLabel>
                <TrackingSummaryValue>{jadlogTracking.tracking.shipmentId}</TrackingSummaryValue>
              </TrackingSummaryItem>
            </TrackingSummary>

            <JadlogTable>
              <thead>
                <tr>
                  <th>Data / Hora</th>
                  <th>Status</th>
                  <th>Unidade</th>
                </tr>
              </thead>
              <tbody>
                {[...jadlogTracking.tracking.eventos].reverse().map((evento, index) => (
                  <tr key={index}>
                    <td>{formatEventDate(evento.data)}</td>
                    <td>{evento.status}</td>
                    <td>{evento.unidade}</td>
                  </tr>
                ))}
              </tbody>
            </JadlogTable>
          </>
        )}
      </InfoCardContainer>}

      {isTotalExpressCarrier && <InfoCardContainer>
        <TitleContent>
          <h3>Rastreamento Total Express</h3>
        </TitleContent>

        {isLoadingTotalExpress && (
          <p style={{ padding: '0 16px 12px', fontSize: 13, color: 'var(--color-text-secondary)' }}>
            Buscando rastreamento...
          </p>
        )}

        {!isLoadingTotalExpress && totalExpressError && (
          <p style={{ padding: '0 16px 12px', fontSize: 13, color: 'var(--color-text-secondary)' }}>
            {totalExpressError}
          </p>
        )}

        {!isLoadingTotalExpress && totalExpressShipment && (
          <>
            <TrackingSummary>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>Status atual</TrackingSummaryLabel>
                <TrackingSummaryValue>
                  {totalExpressShipment.tracking.length > 0
                    ? [...totalExpressShipment.tracking].sort((a, b) =>
                        new Date(b.data).getTime() - new Date(a.data).getTime()
                      )[0].descricao
                    : '—'}
                </TrackingSummaryValue>
              </TrackingSummaryItem>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>Previsão de entrega</TrackingSummaryLabel>
                <TrackingSummaryValue>
                  {totalExpressShipment.previsaoEntregaAtualizada
                    ? formatDeliveryDate(totalExpressShipment.previsaoEntregaAtualizada)
                    : '—'}
                </TrackingSummaryValue>
              </TrackingSummaryItem>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>AWB Total Express</TrackingSummaryLabel>
                <TrackingSummaryValue>{totalExpressShipment.awb}</TrackingSummaryValue>
              </TrackingSummaryItem>
            </TrackingSummary>

            <JadlogTable>
              <thead>
                <tr>
                  <th>Data / Hora</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {[...totalExpressShipment.tracking]
                  .sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime())
                  .map((evento, index) => (
                    <tr key={index}>
                      <td>{formatEventDate(evento.data)}</td>
                      <td>{evento.descricao}</td>
                    </tr>
                  ))}
              </tbody>
            </JadlogTable>
          </>
        )}
      </InfoCardContainer>}

      {isPatrusCarrier && <InfoCardContainer>
        <TitleContent>
          <h3>Rastreamento Patrus</h3>
        </TitleContent>

        {isLoadingPatrus && (
          <p style={{ padding: '0 16px 12px', fontSize: 13, color: 'var(--color-text-secondary)' }}>
            Buscando rastreamento...
          </p>
        )}

        {!isLoadingPatrus && patrusError && (
          <p style={{ padding: '0 16px 12px', fontSize: 13, color: 'var(--color-text-secondary)' }}>
            {patrusError}
          </p>
        )}

        {!isLoadingPatrus && patrusData && (
          <>
            <TrackingSummary>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>Status atual</TrackingSummaryLabel>
                <TrackingSummaryValue>
                  {patrusData.Eventos.length > 0
                    ? patrusData.Eventos[patrusData.Eventos.length - 1].Descricao
                    : '—'}
                </TrackingSummaryValue>
              </TrackingSummaryItem>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>Previsão de entrega</TrackingSummaryLabel>
                <TrackingSummaryValue>
                  {patrusData.DocumentoTransporte?.PrevisaoEntrega
                    ? formatDeliveryDate(patrusData.DocumentoTransporte.PrevisaoEntrega)
                    : '—'}
                </TrackingSummaryValue>
              </TrackingSummaryItem>
              <TrackingSummaryItem>
                <TrackingSummaryLabel>Pedido Patrus</TrackingSummaryLabel>
                <TrackingSummaryValue>{patrusData.Pedido}</TrackingSummaryValue>
              </TrackingSummaryItem>
            </TrackingSummary>

            <JadlogTable>
              <thead>
                <tr>
                  <th>Data / Hora</th>
                  <th>Status</th>
                  <th>Detalhe</th>
                </tr>
              </thead>
              <tbody>
                {[...patrusData.Eventos].reverse().map((evento, index) => (
                  <tr key={index}>
                    <td>{formatEventDate(evento.Data)}</td>
                    <td>{evento.Descricao}</td>
                    <td>{evento.Detalhe.replace(/<[^>]+>/g, '')}</td>
                  </tr>
                ))}
              </tbody>
            </JadlogTable>
          </>
        )}
      </InfoCardContainer>}

      <ButtonContainer />
    </RastreioContainer>
  );
}
